const state = {
    title: '',
    survey_id: null,
    edit_ques: false,

    greetings: {},
    warnings: {},
};

const mutations = {
    // 问卷管理
    setAddData(state, payload) {
        state.title = payload.title;
        state.survey_id = payload.survey_id
    },
    setEditQues(state, payload) {
        // 确保编辑、新增问卷时只有一道题目处于编辑状态
        state.edit_ques = payload
    },
    // 问候语
    setGreetingsAdd(state, payload) {
        state.greetings = payload
    },
    // 通用提醒
    setWarningsAdd(state, payload) {
        state.warnings = payload
    }
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}